















































































































import { Component, mixins, namespace } from 'nuxt-property-decorator'
import { PRIVACY_POLICY_PATH } from '~/assets/config/path'
import { socialIcons } from '~/assets/images/social/icons'
import { filterUrl } from '~/assets/filters/url'
import { ILinkItem } from '~/assets/interfaces/navigation'
import { IPaySystem } from '~/assets/interfaces/paysystems'
import { ILayoutFooterSitemapItem } from '~/assets/interfaces/layout'
import { IStyle } from '~/assets/interfaces/classes'
import { ISocialLinkList } from '~/assets/interfaces/socials'
import MixinGeneral from '~/assets/mixins/general'

const siteStore = namespace('site')

// Подвал для обеих веток: на десктопе пять колонок, на мобильной —
// одна, по центру, без блока приложений.
@Component({
  components: {
    ComponentImage: () => import('~/components/images/image.vue'),
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentMobileAppGet: () => import('~/components/mobile/app/get-app.vue'),
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentFooter extends mixins(MixinGeneral) {
  @siteStore.State('footerContacts') private footerContacts!: ILinkItem[]
  @siteStore.State('copyright') private copyright!: string
  @siteStore.State('paySystems') private paySystems!: IPaySystem[]
  @siteStore.State('hiddenCopyright') private hiddenCopyright!: boolean
  @siteStore.State('footerSitemap') sitemap!: ILayoutFooterSitemapItem[]
  @siteStore.State('social') private socialLinks!: ISocialLinkList | null
  @siteStore.Getter('getOptionsCopyright')
  readonly getOptionsCopyright!: boolean

  private styleGrid!: IStyle
  private styleGridMobile!: IStyle
  private styleSpacer!: IStyle

  private PRIVACY_POLICY_PATH = PRIVACY_POLICY_PATH
  private socialIcons = socialIcons

  // Контейнер у веток свой: разные боковые поля.
  private get classWrapper() {
    return [
      this.isMobile ? this.styleGridMobile.container : this.styleGrid.container,
      this.$style.wrapper,
      this.classDevice(this.$style),
    ]
  }

  private get infoMenuBottom1() {
    return this.sitemap.find((item) => item.type === 'bottom1') || null
  }

  private get infoMenuBottom2() {
    return this.sitemap.find((item) => item.type === 'bottom2') || null
  }

  private socialStyle(key: string) {
    const icon = socialIcons[key]
    return icon ? { '--social-color': icon.color } : {}
  }

  private get isShowCopyright() {
    return this.getOptionsCopyright && !this.hiddenCopyright
  }

  astdesignLink = 'https://astdesign.ru/'

  mounted() {
    const host = window.location.hostname || 'unknown'
    const params = new URLSearchParams({
      utm_source: host,
      utm_medium: 'footer',
      utm_campaign: 'marketpro_devlink',
      utm_content: 'copyright',
    })
    this.astdesignLink = `https://astdesign.ru/?${params.toString()}`
  }
}
